<template>
  <section>
    <div class="row p-lg-4 p-3" v-if="deleteAccountConditions">
      <div class="col-lg-6 offset-lg-3 col-12 delete-account-conditions">
        <div
          v-html="($i18n.locale === 'th') ? deleteAccountConditions.detail_th : deleteAccountConditions.detail_en"></div>
        <hr>
        <div class="pb-4" v-if="!deleteAccountConditions.can_delete_account">
          {{ $t('message.delete_account.cannot_delete_remark') }}
        </div>
        <div class="d-flex justify-content-start align-items-center">
          <div class="flex-fill text-left">
            <router-link to="/user/edit" class="btn-link">
              < {{ $t('message.booking.new_booking.back') }}
            </router-link>
          </div>
          <div class="flex-fill text-right">
            <button class="btn btn-danger"
                    v-if="deleteAccountConditions.can_delete_account"
                    @click="openDeleteAccountDialog()">
              {{ $t('message.delete_account.title') }}
            </button>
            <a href="https://line.me/R/ti/p/%40hnk7011n"
               target="_blank"
               class="btn btn-info"
               v-else>
              {{ $t('message.button.contact_admin') }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { deleteUser } from 'firebase/auth'
  import { firebaseAuth } from '../../helpers/firebaseHelpers'

  export default {
    data () {
      return {
        deleteAccountConditions: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      async fetchDeleteAccountConditions () {
        const url = `users/${this.user.id}/delete-account-conditions`
        const {data} = await axios.get(url)
        if (!data.error) {
          this.deleteAccountConditions = data.delete_account_conditions
        }
      },
      async deleteAccount () {
        const url = `users/${this.user.id}/delete-account`
        const {data} = await axios.post(url)
        if (!data.error) {
          // Clear logged in and booking data in localstorage
          this.$store.commit('auth/SET_USER', null)
          this.$store.commit('auth/SET_TOKEN', null)
          this.$store.commit('booking/SET_PRE_BOOKING_DATA', null)
          this.$store.commit('booking/SET_USER_PLACE_DATA', null)
          this.$store.commit('payment/SET_PAYMENT_DETAIL', null)
          this.openCompleteDialog()
        }
      },
      openDeleteAccountDialog () {
        this.$swal({
          type: 'warning',
          text: this.$i18n.t('message.delete_account.confirm_dialog_message'),
          showCancelButton: true,
          reverseButtons: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#9E9E9E',
          confirmButtonText: this.$i18n.t('message.button.delete'),
          cancelButtonText: this.$i18n.t('message.button.cancel')
        }).then((result) => {
          if (result) {
            this.deleteAccount()
          }
        })
      },
      openCompleteDialog () {
        this.$swal({
          type: 'success',
          allowOutsideClick: false,
          title: this.$i18n.t('message.delete_account.success_delete_title'),
          text: this.$i18n.t('message.delete_account.success_delete_message'),
          confirmButtonText: this.$i18n.t('message.button.ok')
        }).then((result) => {
          if (result) {
            // Delete firebase user
            const user = firebaseAuth.currentUser
            deleteUser(user).then(() => {
              console.log('check deleted firebase account')
              this.$router.push('/')
            }).catch((error) => {
              // An error happened.
              console.log(error)
            })
          }
        })
      }
    },
    mounted () {
      this.fetchDeleteAccountConditions()
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/user/DeleteAccount.vue